/**
 * RESPONSIBILITY: draw the dates an event falls on.
 *
 * Covers the two shapes a church page asks for with one list: the bare run of dates a
 * recurring evening keeps, and a season's service times where each one has its own words
 * and its own booking link. The optional parts simply stay empty for the first.
 */
import { idOf } from '@framework/core';
import { THEME } from '@app/sections';
import { Band } from './Band';
import { momentText } from '../../commons/when';
import type { BandProps } from './kind';

export function Schedule({ s }: BandProps) {
  const dates = (s.schedule ?? []).filter((d) => d.when);
  if (!dates.length) return null;

  return (
    <Band theme={THEME.Schedule} heading={s.heading}>
      <ul className="ev-schedule">
        {dates.map((d) => (
          <li key={idOf(d)}>
            <time className="ev-when">{momentText(d.when)}</time>
            {d.label ? <span className="ev-what">{d.label}</span> : null}
            {d.note ? <span className="ev-aside">{d.note}</span> : null}
            {d.href ? <a className="ev-book" href={d.href}>{d.hrefLabel}</a> : null}
          </li>
        ))}
      </ul>
    </Band>
  );
}
